import type { PointsRangeItemDefinition } from "./PointsRange.types";

export const pointsRangeStoriesItems: PointsRangeItemDefinition[] = [
  {
    value: "0-500",
    displayName: "0 - 500 points",
  },
  {
    value: "500-1000",
    displayName: "500 - 1000 points",
  },
  {
    value: "1000-2500",
    displayName: "1000 - 2500 points",
  },
  {
    value: "2500+",
    displayName: "2500+ points",
  },
];
